import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./layout";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import firebase from "firebase";
import Providers from "./store/Providers";

axios.defaults.baseURL = process.env.REACT_APP_URL_API;

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MASSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  });
} else {
  firebase.app(); // if already initialized, use that one
}

function App() {
  return (
    <div className="App">
      <Router>
        <Providers>
          <Layout />
        </Providers>
      </Router>
    </div>
  );
}

export default App;
